import React, { useEffect } from 'react';

import { Snackbar } from '@amzn/storm-ui';

import { SHARED_CONSTANTS } from '../../Shared/constants/commonConstants';
import { ErrorTooltip } from '../../Shared/components/ErrorTooltip';

import { SnackbarVariants } from './constants/snackbarVariants';
import { SnackbarContainer, SnackbarContentWrapper } from './CustomSnackbar.styles';

interface CustomSnackbarProps {
  id?: string;
  variant: SnackbarVariants;
  message: string;
  isVisible: boolean;
  onClose: () => void;
  technicalDetails?: string;
}

export const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  id,
  variant,
  message,
  isVisible,
  onClose,
  technicalDetails,
}) => {
  useEffect(() => {
    if (isVisible && variant === SnackbarVariants.SUCCESS) {
      const timer = setTimeout(() => {
        onClose();
      }, SHARED_CONSTANTS.SUCCESS_SNACKBAR_CLEAR_TIME);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose, variant]);

  if (!isVisible) return null;

  return (
    <SnackbarContainer>
      <Snackbar id={id} variant={variant} onClose={onClose}>
        <SnackbarContentWrapper>
          {message}
          {technicalDetails && <ErrorTooltip message={technicalDetails} />}
        </SnackbarContentWrapper>
      </Snackbar>
    </SnackbarContainer>
  );
};
